import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import moment from 'moment'
import { toBuddhistYear } from 'utils/app.utils'
import { forceTextOnDateCells } from 'utils/excel.utils'

async function ExportToExcel({
    data,
    branches,
    branchId,
    filter,
    filterDateStart,
    filterDateEnd,
    snType,
    t,
}: {
    data: any[]
    branches: any[]
    branchId: number
    filter: any
    filterDateStart: string
    filterDateEnd: string
    snType: boolean
    t: any
}) {
    try {
        if (!Array.isArray(data) || data.length === 0) {
            alert(t('REPORT.TITLE.NO_DATA'));
            return;
        }
        const workbook = new ExcelJS.Workbook()
        const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.TREATMENT_COURES'))

        const titleRow = sheet.addRow([t('REPORT.REPORT_NAME.TREATMENT_COURES')])
        titleRow.font = { bold: true, size: 16 }
        sheet.mergeCells(titleRow.number, 1, titleRow.number, 20)
        titleRow.alignment = { horizontal: 'left' }

        // Filter info (horizontal)
        const filterLabels = [
            t('REPORT.FILTER.BRANCH'),
            t('REPORT.FILTER.COURSE_NAME'),
            t('REPORT.FILTER.DATE_START'),
            t('REPORT.FILTER.DATE_END'),
        ]
        const filterValues = [
            branchId === 0 ? t('REPORT.FILTER.ALL') : _.get(_.find(branches, { branchId }), 'branchName', ''),
            filter.courseType || t('REPORT.FILTER.ALL'),
            filterDateStart ? toBuddhistYear(moment(filterDateStart), 'DD/MM/YYYY') : '-',
            filterDateEnd ? toBuddhistYear(moment(filterDateEnd), 'DD/MM/YYYY') : '-',
        ]

        const filterRowData: any[] = []
        for (let i = 0; i < filterLabels.length; i++) {
            filterRowData.push(filterLabels[i] + ':', filterValues[i])
        }
        const filterRow = sheet.addRow(filterRowData)
        filterRow.font = { size: 11 }
        for (let col = 1; col <= filterRowData.length; col += 2) {
            filterRow.getCell(col).font = { bold: true }
            filterRow.getCell(col).alignment = { horizontal: 'left' }
            filterRow.getCell(col + 1).alignment = { horizontal: 'left' }
        }
        sheet.addRow([])

        const headCells = [
            { label: t('REPORT.TABLE.TREATMENT_COURES.#NO'), width: 10 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.DATE_TINE'), width: 20 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.CN'), width: 15 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.SN_CODE'), width: 15 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.FULL_NAME'), width: 25 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.COURES_NAME'), width: 25 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.PRICE'), width: 15 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.TOTAL'), width: 15 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.AMOUNT_USED'), width: 15 },
            { label: t('REPORT.TABLE.TREATMENT_COURES.BALANCE'), width: 15 },
        ]
        if (!snType) {
            headCells.splice(3, 1)
        }

        sheet.columns = headCells.map(c => ({ width: c.width }))

        const headerRow = sheet.addRow(headCells.map(c => c.label))
        headerRow.font = { bold: true, size: 12 }
        headerRow.alignment = { horizontal: 'left', vertical: 'middle' }

        for (const row of data) {
            const rowData = [
                data.indexOf(row) + 1,
                row.updatedAt ? toBuddhistYear(moment(row.updatedAt), 'DD/MM/YYYY HH:mm น.') : t(`REPORT.VALUE.PATIENT.BLOOD_TYPE.NOT_SPECIFIED`),
                row.cnNumber || '-',
                row.snCode || '-',
                row.fullName || '-',
                row.itemName || '-',
                row.price || '-',
                row.sum || '-',
                row.used || '-',
                row.balance || '-',
            ]
            if (!snType) {
                rowData.splice(3, 1)
            }
            sheet.addRow(rowData)
        }

        forceTextOnDateCells(workbook)
        const buffer = await workbook.xlsx.writeBuffer()
        const timestamp = moment().format('YYYYMMDD_HHmmss')
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        saveAs(blob, `${t('REPORT.REPORT_NAME.TREATMENT_COURES')}_${timestamp}.xlsx`)
    } catch (error) {
        console.error('Error exporting to Excel:', error);
    }
}

export default ExportToExcel 